<!-- 统计图 -->
<template>
<basicContainer>
  <el-form :inline="true" :model="formInline">
    <el-form-item label="查看模式">
      <el-select v-model="formInline.statisticsType" placeholder="请选择查看模式">
        <el-option label="按年查看" disabled value="YEAR"></el-option>
        <el-option label="按月查看" value="MONTH"></el-option>
        <el-option label="按天查看" value="DAY"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="统计时间段">
      <avue-date v-model="formInline.time" format='yyyy-MM-dd' type="daterange" valueFormat='yyyy-MM-dd' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" align="right" unlink-panels>

      </avue-date>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">查询</el-button>
       <el-button type="success" @click="$router.push('/pagingStatistics')">查看详情</el-button>
    </el-form-item>
  </el-form>

  <div id="chart" :style="{zoom:scale}"></div>
</basicContainer>
</template>

<script>
// import echarts from 'echarts/lib/chart/line'
// let echarts = require('echarts/lib/echarts');
// 引入提示框和title组件
// require('echarts/lib/component/tooltip');
// require('echarts/lib/component/title');
// import echarts from 'echarts'
import HighCharts from 'highcharts'

export default {
  data() {
    return {
      scale: 1,
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      formInline: {
        statisticsType: 'DAY',
        time: []
      }
    }
  },

  components: {},

  mounted: function() {
    // 设置 初始化时间
    // const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.formInline.time = [
      this.getDate(start),

      this.getDate(new Date())
    ]
    this.onSubmit()
  },
  created() {
    if (document.documentElement.style.zoom) {
      this.scale = 1 / document.documentElement.style.zoom
    }
  },
  methods: {
    getDate(nowDate, ismouth) {
      var year = nowDate.getFullYear()
      var month = nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1)
        : nowDate.getMonth() + 1
      var day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate
        .getDate()
      if (ismouth) {
        return year + '-' + month
      } else {
        return year + '-' + month + '-' + day
      }
    },
    getAllMouth(start, end) {
      var result = []
      var s = start.split('-')
      var e = end.split('-')
      var min = new Date()
      var max = new Date()
      min.setFullYear(s[0], s[1])
      max.setFullYear(e[0], e[1])

      var curr = min
      while (curr <= max) {
        var month = curr.getMonth()
        let tempMonth = month
        if (tempMonth === 0) {
          tempMonth = 12
        }
        result.push(curr.getFullYear() + '-' + (tempMonth < 10 ? ('0' + tempMonth) : tempMonth))
        curr.setMonth(month + 1)
      }
      return result
    },
    getAllDay(begin, end) {
      var arr = []
      var ab = begin.split('-')
      var ae = end.split('-')
      var db = new Date()
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
      var de = new Date()
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
      var unixDb = db.getTime() - 24 * 60 * 60 * 1000
      var unixDe = de.getTime() - 24 * 60 * 60 * 1000
      for (var k = unixDb; k <= unixDe;) {
        k = k + 24 * 60 * 60 * 1000
        arr.push(this.getDate(new Date(parseInt(k))))
      }
      return arr
    },
    onSubmit() {
      this.$http.post('/account-modify-audit/statistics', null, {
        params: {
          statisticsType: this.formInline.statisticsType,
          startTime: this.getDate(new Date(this.formInline.time[0]), this.formInline.statisticsType === 'MONTH'),
          moreField: 'modifyType',
          endTime: this.getDate(new Date(this.formInline.time[1]), this.formInline.statisticsType === 'MONTH')
        }
      }).then(response => {
        if (this.formInline.statisticsType === 'MONTH') {
          let xAxis = this.getAllMouth(this.getDate(new Date(this.formInline.time[0]), true), this.getDate(new Date(this.formInline.time[1]), true))
          let addDataList = []
          let modDataList = []
          let delDataList = []
          // 月
          response.data.forEach(item => {
            let index = xAxis.findIndex(ele => ele === item.auditTime)
            if (index !== -1) {
              switch (item.modifyType) {
                case 1: {
                  return (addDataList[index] = item.cnt)
                }
                case 2: {
                  return (modDataList[index] = item.cnt)
                }
                case 3: {
                  return (delDataList[index] = item.cnt)
                }
              }
            }
          })
          for (let i = 0; i < xAxis.length; i++) {
            addDataList[i] = addDataList[i] || 0
            modDataList[i] = modDataList[i] || 0
            delDataList[i] = delDataList[i] || 0
          }
          this.drawView({
            xAxis,
            addDataList,
            modDataList,
            delDataList
          })
        } else {
          // 天
          let xAxis = this.getAllDay(this.formInline.time[0], this.formInline.time[1])
          let addDataList = []
          let modDataList = []
          let delDataList = []
          response.data.forEach(item => {
            let index = xAxis.findIndex(ele => ele === item.auditTime)
            if (index !== -1) {
              switch (item.modifyType) {
                case 1: {
                  return (addDataList[index] = item.cnt)
                }
                case 2: {
                  return (modDataList[index] = item.cnt)
                }
                case 3: {
                  return (delDataList[index] = item.cnt)
                }
              }
            }
          })
          for (let i = 0; i < xAxis.length; i++) {
            addDataList[i] = addDataList[i] || 0
            modDataList[i] = modDataList[i] || 0
            delDataList[i] = delDataList[i] || 0
          }
          this.drawView({
            xAxis,
            addDataList,
            modDataList,
            delDataList
          })
        }
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
    drawView(data) {
      HighCharts.chart('chart', {
        title: {
          text: '账号统计',
          x: -20 // center
        },
        xAxis: {
          categories: data.xAxis,
          labels: {
            rotation: 65
          }
        },
        yAxis: {
          title: {
            text: '次数 (次)'
          },
          allowDecimals: false, // 是否允许刻度有小数
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        tooltip: {
          valueSuffix: '次'
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0
        },
        series: [{
          name: '新增账号',
          data: data.addDataList
        },
        {
          name: '修改账号',
          data: data.modDataList
        },
        {
          name: '删除账号',
          data: data.delDataList
        }
        ]
      })
    }
  }
}
</script>
<style lang='scss' scoped>

</style>
